import Vue from 'vue';

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import App from './App.vue';
import router from './router';
import store from './store';
import loading from './plugins/directives';

import '@/assets/styles/styles.scss';

if (process.env.VUE_APP_ENV === 'staging') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_URL,
    integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  });
}

Vue.config.productionTip = false;

Vue.directive('loading', loading);

router.afterEach(async (to, from) => {
  const routerApp: any = router.app;
  routerApp.loading = false;
});

new Vue({
  router,
  store,
  data() {
    return {
      authenticated: false,
      loading: true,
    };
  },
  render: h => h(App),
}).$mount('#app');
